export type Pagination<TData> = {
  limit: number;
  page: number;
  totalPages: number;
  count: number;
  items: TData;
  cursor?: string;
};

export type CursorPagination<TData> = {
  cursor: string | null;
  items: TData;
};

export enum ResponseCode {
  NO_FORM_ATTEMPTS_AVAILABLE = 'NO_FORM_ATTEMPTS_AVAILABLE',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
}

export type ResponseError = {
  code: string;
  message: string;
};
